import { render, staticRenderFns } from "./CriarEsclarecimentoImpugnacao.vue?vue&type=template&id=70ec2c80&"
import script from "./CriarEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
export * from "./CriarEsclarecimentoImpugnacao.vue?vue&type=script&lang=js&"
import style0 from "./CriarEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=70ec2c80&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports